import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTBActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import BlockersStats from '../../Common/components/BlockersStats';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import CTBChart from '../components/CTBChart';
import CTBreakdown from '../components/CTBreakdown';

import './../CTB.scss';

export class CTB extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    props.dispatch(setPageName('Cycle time breakdown'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('ctb');

      trackTeamDashboardView('ctb');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('ctb', true);
  };

  trackHowToCTBOpen() {
    trackHowToOpened('ctb');
  }

  getBlockersFlags() {
    const { app, dashboard } = this.props;
    const showBlockers = app === 'trello' || app === 'azure' || app === 'jira' || (app === 'file' && !dashboard.isAzure);
    const blockersDisabled =
      app === 'jira' && dashboard.isBusiness && !dashboard.selectedBlockedFlag ||
      app === 'trello' &&  !dashboard.selectedBlockedFlag || 
      app === 'azure' && !dashboard.selectedBlockedFlag;
    return { showBlockers, blockersDisabled };
  }

  render() {
    const { showBlockers, blockersDisabled } = this.getBlockersFlags();   
    const blockersStats = showBlockers && this.props.data && this.props.data.blockersStats;

    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Analyze your cycle time breakdown</li>
            <li>Identify bottlenecks that hinder your performance</li>
            <li>Highlight the disruptive nature of your waiting times</li>
          </ul>
          <a
          href={`https://getnave.com/cycle-time-breakdown-chart`}
          target="_blank"
          onClick={this.trackHowToCTBOpen}
          onAuxClick={this.trackHowToCTBOpen} 
          className='btn btn-secondary'
          >
            Learn more
        </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.cycleTimes, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet title={`Cycle Time Breakdown Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        <Filter totalItems={totalItems} timeunit dateformat enableMarkBlocked enableBreakdownBy disable={[]} />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Cycle Time Breakdown Chart
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options
                showBreakdown
                showBlockers={showBlockers}
                blockersDisabled={blockersDisabled}
              />
              <DatePicker />
            </div>
          </div>
          <div>
            <div className="dashboard_details">
              {blockersStats && this.props.blockersChart && (
                <BlockersStats id="stats" data={blockersStats} />
              )}
              {this.props.breakdown && this.props.data.cycleTimes && !!this.props.data.cycleTimes.length && (
                <CTBreakdown id="ctbreakdown" data={this.props.data.cycleTimes} widget="ctb" />
              )}
              <DetailsAccordion
                dateLabel={this.props.timeUnit === 'cards' ? 'Name' : 'Date'}
                valueLabel="Cycle time"
                value2Label="Throughput"
                chart="ctb"
                id="details-accordion"
                data={this.state.selectedPoint}
              />
            </div>
            <div className="diagram_details">
              <CTBChart
                id="CTB"
                data={this.props.data.breakdown}
                throughput={this.props.data.throughput}
                onPointClick={this.handlePointClick}
              />
              <NoData
                show={this.props.data.breakdown && !this.props.data.breakdown.length}
                loading={this.props.isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    hash: state.filters.ctb.hash,
    breakdown: state.filters.ctb.breakdown,
    timeUnit: state.filters.ctb.timeUnit,
    breakdownBy: state.filters.ctb.breakdownBy,
    blockersChart: state.filters.ctb.blockersChart,
    data: state.ctb.data,
    isLoading: state.ctb.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTB);
